import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { linkedinPostThunks } from './linkedinPostThunks';
import type { LinkedinPostState } from './linkedinPostTypes';

const initialState: LinkedinPostState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

export const linkedinPostSlice = createSlice({
  name: 'linkedinPosts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCrudCases(builder, linkedinPostThunks, (l) => l.linkedinPostId);
  },
});

export const linkedinPostReducer = linkedinPostSlice.reducer;
